export const API_URL = process.env.REACT_APP_BACKEND_URL
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
export const GM_API_KEY = process.env.REACT_APP_GM_API_KEY
export const GM_LIBRARIES = ['places']
export const FE_VERSION = process.env.REACT_APP_FE_VERSION
export const BE_VERSION = process.env.REACT_APP_BE_VERSION
